import { fileExtension } from './fileExtension'

// pdf is its own kind because it renders through react-pdf, while uploaded html stays in a sandboxed frame
export type PreviewKind = 'pdf' | 'frame' | 'image'

// tiff is uploadable but no major browser renders it in <img>, so it stays unpreviewable
const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'bmp']

/** How a document can be previewed in-browser, or null when it can only be downloaded. */
export const previewKind = (fileName: string): PreviewKind | null => {
  const ext = fileExtension(fileName)
  if (ext === null) return null
  if (ext === 'pdf') return 'pdf'
  if (ext === 'html' || ext === 'htm') return 'frame'
  if (IMAGE_EXTENSIONS.includes(ext)) return 'image'
  return null
}
